module.exports = __webpack_public_path__ + "img/WechatIMG19.1742753e.jpeg";